module.exports = __webpack_public_path__ + "static/media/Website.aecc1f98.png";